import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import type { SearchSchemaInput } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { parseEnum, validateListSearch } from '@/shared/lib/listSearch';

export const salesRequestsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/sales-requests',
  component: lazyRouteComponent(() => import('./pages/SalesRequestsPage'), 'SalesRequestsPage'),
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    ...validateListSearch(search),
    status: parseEnum(search.status, ['new', 'contacted', 'closed'] as const),
  }),
});

export const salesRequestsRoutes = [salesRequestsRoute];
